import { put, call, select, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';
import moment from 'moment';

//Action
function* notificationGet(action) {
  const state = yield select();

  const {res} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('myProfileDatetime', moment(state.my.profile.datetime).format("YYYY-MM-DD HH:mm:ss"));
    return axios.post(config.apiUri + "member/notificationApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool) {
      yield put({
        type: "NOTIFICATION_SET",
        payload: {
          mailUnconfirmed: res.data.mailUnconfirmed,
          bestpartnerUnconfirmed: res.data.bestpartnerUnconfirmed,
          favoriteNoticeUnconfirmed: res.data.favoriteNoticeUnconfirmed,
          paymentTicketSenderUnused: res.data.paymentTicketSenderUnused,
          paymentTicketReceiverUnseen: res.data.paymentTicketReceiverUnseen,
          coupleReception: res.data.coupleReception,
          coupleRequest: res.data.coupleRequest,
          couple: res.data.couple,
          newsUnread: res.data.newsUnread,
        }
      });
    }
  }
}

const saga = [
  takeLatest('NOTIFICATION_GET', notificationGet),
];

export default saga;
